const initialState = {
    partnerForAccount:[],
    paymentProfileList: [],
    paymentRuleList: [],
    resultsPaymentRuleGet: {},
    resultsPaymentRuleCreate: {},
    resultsPaymentRuleUpdate: {},
    resultsPaymentRuleDelete: {},
    errorResponse: {}
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };
    switch (action.type) {
        case "PARTNER_FOR_ACCOUNT_RESPONSE_GET":
            newState.partnerForAccount = action.value.result.partners;
            break;
        case "PAYMENTPROFILE_RESPONSE_GET":
            newState.paymentProfileList = action.value.result.profiles;
            break;
        case "PAYMENTRULE_RESPONSE_GET":
            newState.paymentRuleList = action.value.result.rules;
            newState.resultsPaymentRuleGet = action.value;
            break;
        case "PAYMENTRULE_RESPONSE_CREATE":
            newState.resultsPaymentRuleCreate = action.payload;
            break;
        case "PAYMENTRULE_RESPONSE_UPDATE":
            newState.resultsPaymentRuleUpdate = action.payload;
            break;
        case "PAYMENTRULE_RESPONSE_DELETE":
            newState.resultsPaymentRuleDelete = action.payload;
            break;
        case "RESET_PAYMENT_RULE_RESPONSE":
            newState.resultsPaymentRuleGet = {};
            newState.resultsPaymentRuleCreate = {};
            newState.resultsPaymentRuleUpdate = {};
            newState.resultsPaymentRuleDelete = {};
            newState.error = {}
            break;
        case "SET_ERROR":
            newState.errorResponse = action.payload;
            break;
        case "RESET_ERROR":
            newState.errorResponse = {};
            break;
        default:
            break;
    }
    return newState;
}

export default reducer;